import { http } from '../http';

export class ApprovalRequestsAPI {

    private static INSTANCE = new ApprovalRequestsAPI();

    static get instance() {
        return this.INSTANCE;
    }

    private namespace = 'api/v1/admin-utils';
    private namespace3 = 'api/admin/v1';
    private namespace2 = 'api/nucleus/v1';

    public getUserList(params: any) {
        const endpoint = `${this.namespace}/users/list`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header, params).then((response) => {
            return response;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }
    public getGradeId() {
        const endpoint = `${this.namespace2}/lookups/common/grade/levels`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header).then((response) => {
            return response;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public getSubjectList(params: any) {
        const endpoint = `${this.namespace3}/group/hierarchy/mapping/all`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header, params).then((response) => {
            return response;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public updateUserStaus(params: any) {
        const endpoint = `${this.namespace}/users/status`;
        const header = http.getTokenHeaders();
        return http.put(endpoint, header, params).then((response) => {
            return response;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public editUserData(params: any) {
        const endpoint = `${this.namespace}/users/requested`;
        const header = http.getTokenHeaders();
        return http.patch(endpoint, header, params).then((response) => {
            return response;
        }).catch((error: any) => {
            return { message: error };
        });
    }
}
export const approvalRequestsAPI = ApprovalRequestsAPI.instance;





